import React, { useState } from "react";
import "../components/App.css";
import axios from "axios";
import { API_BASE_URL } from "../config/config";
import { Container, Avatar, Button } from "@mui/material";
import PasswordField from "../components/PasswordField";
import { useActiveCareUser } from "../hooks/useActiveCareUser";

const MyAccount = () => {
  const { userDetails: baseUserDetails } = useActiveCareUser();
  const [iconUrl, setIconUrl] = useState(null);
  const userDetails = iconUrl
    ? { ...baseUserDetails, icon: iconUrl }
    : baseUserDetails;
  const [passwordData, setPasswordData] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  });
  const [passwordError, setPasswordError] = useState("");

  const handleChange = (e) => {
    setPasswordData({
      ...passwordData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const token = localStorage.getItem("care_token");
      const response = await axios.post(
        `${API_BASE_URL}/resetpass`,
        {
          email: userDetails.email,
          newPass: passwordData.newPassword,
          confirmPass: passwordData.confirmPassword,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      alert(response.data.msg);
      setPasswordData({
        currentPassword: "",
        newPassword: "",
        confirmPassword: "",
      });
    } catch (error) {
      console.error("Error resetting password:", error.response.data.msg);
      setPasswordError(error.response.data.msg);
    }
  };

  const handleImageUpload = async (e) => {
    const token = localStorage.getItem("care_token");
    const formData = new FormData();
    formData.append("img", e.target.files[0]);
    formData.append("email", userDetails.email);
    try {
      const response = await axios.post(`${API_BASE_URL}/icon`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });
      setIconUrl(response.data.iconUrl);
    } catch (error) {
      console.error("Error updating icon:", error);
    }
  };

  const renderPasswordResetForm = () => (
    <div className="password-reset-container" style={{ marginTop: "2rem" }}>
      <h3 style={{ textAlign: "center", marginBottom: "3rem" }}>
        Reset Password
      </h3>
      <div className="password-reset-details">
        <form onSubmit={handleSubmit} className="password-reset-form">
          <div className="password-reset-input-group">
            <label htmlFor="currentPassword">
              <strong>Current Password:</strong>
            </label>
            <PasswordField
              name="currentPassword"
              value={passwordData.currentPassword}
              onChange={handleChange}
              required
              fullWidth
              size="small"
              variant="outlined"
            />
          </div>
          <div className="password-reset-input-group">
            <label htmlFor="newPassword">
              <strong>New Password:</strong>
            </label>
            <PasswordField
              name="newPassword"
              value={passwordData.newPassword}
              onChange={handleChange}
              required
              fullWidth
              size="small"
              variant="outlined"
            />
          </div>
          <div className="password-reset-input-group">
            <label htmlFor="confirmPassword">
              <strong>Confirm New Password:</strong>
            </label>
            <PasswordField
              name="confirmPassword"
              value={passwordData.confirmPassword}
              onChange={handleChange}
              required
              fullWidth
              size="small"
              variant="outlined"
            />
          </div>
          <div className="password-reset-submit-button">
            <button type="submit">Reset Password</button>
          </div>
        </form>
        {passwordError && (
          <p style={{ color: "red", marginTop: "1rem" }}>{passwordError}</p>
        )}
      </div>
    </div>
  );

  return (
    <Container>
      <div className="dashboard-page-container">
          <div className="user-container">
            <h2 style={{ textAlign: "center", marginBottom: "2rem" }}>
              My Account
            </h2>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginTop: "1rem",
              }}
            >
              <Avatar
                alt="User Icon"
                src={userDetails.icon}
                sx={{ width: 100, height: 100, marginRight: "1rem" }}
              />
              <div>
                <input
                  type="file"
                  accept="image/*"
                  onChange={handleImageUpload}
                  style={{ display: "none" }}
                  id="image-upload"
                />
                <label htmlFor="image-upload">
                  <Button variant="contained" component="span">
                    Update Image
                  </Button>
                </label>
              </div>
            </div>
            <div className="user-details">
              <div className="space-between">
                <p>
                  <strong>Name:</strong>
                </p>
                <p>
                  {userDetails.fName} {userDetails.mName} {userDetails.lName}
                </p>
              </div>
              <div className="space-between">
                <p>
                  <strong>Email:</strong>
                </p>
                <p>{userDetails.email}</p>
              </div>
              <div className="space-between">
                <p>
                  <strong>Country:</strong>
                </p>
                <p>{userDetails.country}</p>
              </div>
              <div className="space-between">
                <p>
                  <strong>State:</strong>
                </p>
                <p>{userDetails.state}</p>
              </div>
              <div className="space-between">
                <p>
                  <strong>City:</strong>
                </p>
                <p>{userDetails.city}</p>
              </div>
              <div className="space-between">
                <p>
                  <strong>Contact:</strong>
                </p>
                <p>{userDetails.contact}</p>
              </div>
            </div>
          </div>
          {renderPasswordResetForm()}
        </div>
    </Container>
  );
};

export default MyAccount;
